define(['rest/utils', 'http', 'security', '../request/requestParamsFactory',
    'lodash/core', '../request/contentTypeConfigurer'],
function(utils, http, security, createRequestParams, _, contentTypeConfigurer) {

    return function(endpoint, securityKeyName) {
        return function(fields, options, callback) {
            var requestParams = createRequestParams(contentTypeConfigurer.setField(fields),
                    contentTypeConfigurer.setValue(options)),
                pathParams = requestParams.pathParams,
                queryParams = requestParams.queryParams,
                otherParams = requestParams.otherParams,
                httpOptions,
                bodyParams;

            queryParams.key = utils.or(options.key, security.getKey(securityKeyName));
            queryParams.key = utils.required(queryParams.key);

            httpOptions = {
                url: '{protocol}://' + endpoint,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callbackParam: 'callback',
                callback: callback,
                fail: otherParams.fail
            };

            bodyParams = requestParams.postParams;

            if (_.isEmpty(bodyParams)) {
                http.get(httpOptions);
            } else {
                httpOptions.bodyParameters = bodyParams;
                http.post(httpOptions);
            }
        };
    };
});



// WEBPACK FOOTER //
// ./rest/request/singleRequestServiceFactory.js